export type AudioCue = 'BGM_TITLE' | 'BGM_BATTLE' | 'ATTACK' | 'HIT' | 'GUARD' | 'COUNTER' | 'KNOCKDOWN' | 'WAKE' | 'KO' | 'DRAW' | 'TIME_UP';
export interface AudioBackend { play(cue: AudioCue, gain?: number): void | Promise<void>; setGains?(bgm: number, se: number): void; stopAll(): void }
export interface AudioSettingsProvider {
  get(): Readonly<{ audio: Readonly<{ bgmVolume: number; seVolume: number; muted: boolean }> }>;
  subscribe?(listener: () => void): () => void;
}
export class AudioAdapter {
  private readonly unsubscribe: () => void;
  public constructor(private readonly backend: AudioBackend | null = null, private readonly settings?: AudioSettingsProvider) {
    this.unsubscribe = settings?.subscribe?.(() => this.applyGains()) ?? (() => undefined); this.applyGains();
  }
  public getEffectiveGains(): Readonly<{ bgm: number; se: number }> {
    const audio = this.settings?.get().audio ?? { bgmVolume: 1, seVolume: 1, muted: false };
    return Object.freeze({ bgm: audio.muted ? 0 : audio.bgmVolume, se: audio.muted ? 0 : audio.seVolume });
  }
  public play(cue: AudioCue): void {
    try { const gains = this.getEffectiveGains(); const gain = cue.startsWith('BGM_') ? gains.bgm : gains.se;
      void Promise.resolve(this.backend?.play(cue, gain)).catch(() => undefined); } catch { /* safe no-op */ }
  }
  public dispose(): void { this.unsubscribe(); try { this.backend?.stopAll(); } catch { /* safe no-op */ } }
  private applyGains(): void { try { const gains = this.getEffectiveGains(); this.backend?.setGains?.(gains.bgm, gains.se); } catch { /* safe no-op */ } }
}
